import React from 'react'

import './AdPlacement.scss'

import { PubliftZoneSlot } from '@webmotors/media-lib-ui'

const AdPlacement = ({ type = 'default', id, shouldDisplayMidias }) => {
  return (
    <div className={`ad-placement ${type}`}>
      <PubliftZoneSlot id={id} shouldDisplayMidias={shouldDisplayMidias} />
    </div>
  )
}

export default AdPlacement
